import request from '@/utils/request'


// 查询评论举报记录列表
export function listCommentReport(query) {
  return request({
    url: '/tree/commentReport/list',
    method: 'get',
    params: query
  })
}

// 查询评论举报记录分页
export function pageCommentReport(query) {
  return request({
    url: '/tree/commentReport/page',
    method: 'get',
    params: query
  })
}

// 查询评论举报记录详细
export function getCommentReport(data) {
  return request({
    url: '/tree/commentReport/detail',
    method: 'get',
    params: data
  })
}

// 新增评论举报记录
export function addCommentReport(data) {
  return request({
    url: '/tree/commentReport/add',
    method: 'post',
    data: data
  })
}

// 修改评论举报记录
export function updateCommentReport(data) {
  return request({
    url: '/tree/commentReport/edit',
    method: 'post',
    data: data
  })
}

// 删除评论举报记录
export function delCommentReport(data) {
  return request({
    url: '/tree/commentReport/delete',
    method: 'post',
    data: data
  })
}
